import Vue from "vue";
/**
 * setter
 * @method setCampaign
 * @method setPage
 * @method setTag
 * action
 * @method show
 * @method hide
 * method
 *
 * set event
 * @method onClickClose
 * @method onClickAction
 * event
 * @event sendCallbackClose
 * @event sendCallbackAction
 */
export function SerialModalController () {
    this.campaign = {};
    this.page = null;
    this.tag = '';
    this.passcode_category = [];
    this.loadingModal = null;
    this.busModal = new Vue();

    this.callbackClose = null;
    this.callbackAction = null;

    //#region setter
    this.setCampaign = function (campaign) {
        this.campaign = campaign;
        return this;
    };
    this.setPage = function (page) {
        this.page = page;
        return this;
    }
    this.setTag = function (tag) {
        this.tag = tag;
        return this;
    };
    this.setPasscodeCategory = function (passcode_category) {
        this.passcode_category = passcode_category;
        return this;
    };
    this.setLoadingModal = function (loadingModal) {
        this.loadingModal = loadingModal;
    };
    this.clearModal = function () {
        this.campaign = {};
        this.page = null;
        this.tag = null;
        this.passcode_category = [];
        this.callbackAction = null;
        this.callbackClose = null;
    };
    //#endregion setter

    //#region action
    this.show = function () {
        var config = {
            campaign: this.campaign,
            page: this.page,
            passcode_category: this.passcode_category,
            tag: this.tag
        }

        this.busModal.$emit('show', config);
    };

    this.hide = function () {
        this.busModal.$emit('hide');
    };
    //#endregion action

    //#region event
    this.onClickClose = function (callback) {
        if (typeof callback == 'function') {
            this.callbackClose = callback;
        }
    };
    this.sendCallbackClose = function (data) {
        if (typeof this.callbackClose == 'function') {
            this.callbackClose(data);
        }
    };

    this.onClickAction = function (callback) {
        if (typeof callback == 'function') {
            this.callbackAction = callback;
        }
    };
    this.sendCallbackAction = function (data) {
        if (typeof this.callbackAction == 'function') {
            this.callbackAction(data);
        }
    }
    //#endregion event
}
